// import React from 'react'

// const Pagination = ({ pagination, onPageChange }) => {
//   if (!pagination || pagination.totalPages <= 1) {
//     return null
//   }

//   const { currentPage, totalPages, hasNextPage, hasPreviousPage } = pagination

//   const renderPageNumbers = () => {
//     const pages = []
//     const maxVisiblePages = 5
//     let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2))
//     let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1)

//     // Adjust start if we're near the end
//     if (endPage - startPage < maxVisiblePages - 1) {
//       startPage = Math.max(1, endPage - maxVisiblePages + 1)
//     }

//     // First page
//     if (startPage > 1) {
//       pages.push(
//         <button
//           key={1}
//           onClick={() => onPageChange(1)}
//           className="px-3 py-2 rounded-md text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white transition-colors"
//         >
//           1
//         </button>
//       )
//       if (startPage > 2) {
//         pages.push(
//           <span key="ellipsis-start" className="px-2 text-gray-500">
//             ...
//           </span>
//         )
//       }
//     }

//     // Page numbers
//     for (let i = startPage; i <= endPage; i++) {
//       pages.push(
//         <button
//           key={i}
//           onClick={() => onPageChange(i)}
//           className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
//             i === currentPage
//               ? 'bg-[#00d9ff] text-white'
//               : 'text-gray-300 hover:bg-gray-700 hover:text-white'
//           }`}
//         >
//           {i}
//         </button>
//       )
//     }

//     // Last page
//     if (endPage < totalPages) {
//       if (endPage < totalPages - 1) {
//         pages.push(
//           <span key="ellipsis-end" className="px-2 text-gray-500">
//             ...
//           </span>
//         )
//       }
//       pages.push(
//         <button
//           key={totalPages}
//           onClick={() => onPageChange(totalPages)}
//           className="px-3 py-2 rounded-md text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white transition-colors"
//         >
//           {totalPages}
//         </button>
//       )
//     }

//     return pages
//   }

//   return (
//     <div className="flex items-center justify-center gap-2 mt-8 mb-4">
//       {/* Previous button */}
//       <button
//         onClick={() => onPageChange(currentPage - 1)}
//         disabled={!hasPreviousPage}
//         className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
//           hasPreviousPage
//             ? 'bg-gray-800 text-white hover:bg-gray-700'
//             : 'bg-gray-900 text-gray-600 cursor-not-allowed'
//         }`}
//       >
//         Previous
//       </button>

//       {/* Page numbers */}
//       <div className="flex items-center gap-1">
//         {renderPageNumbers()}
//       </div>

//       {/* Next button */}
//       <button
//         onClick={() => onPageChange(currentPage + 1)}
//         disabled={!hasNextPage}
//         className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
//           hasNextPage
//             ? 'bg-gray-800 text-white hover:bg-gray-700'
//             : 'bg-gray-900 text-gray-600 cursor-not-allowed'
//         }`}
//       >
//         Next
//       </button>
//     </div>
//   )
// }

// export default Pagination




import React from 'react'

const Pagination = ({ pagination, onPageChange }) => {
  if (!pagination || pagination.totalPages <= 1) {
    return null
  }

  const { currentPage, totalPages, hasNextPage, hasPreviousPage } = pagination

  const renderPageNumbers = () => {
    const pages = []
    const maxVisiblePages = 5
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2))
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1)

    if (endPage - startPage < maxVisiblePages - 1) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1)
    }

    if (startPage > 1) {
      pages.push(
        <button
          key={1}
          onClick={() => onPageChange(1)}
          className="px-2 sm:px-3 py-1 sm:py-2 rounded-md text-xs sm:text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white transition-colors"
        >
          1
        </button>
      )
      if (startPage > 2) {
        pages.push(
          <span key="ellipsis-start" className="px-1 sm:px-2 text-gray-500">
            ...
          </span>
        )
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          onClick={() => onPageChange(i)}
          className={`px-2 sm:px-3 py-1 sm:py-2 rounded-md text-xs sm:text-sm font-medium transition-colors ${
            i === currentPage
              ? 'bg-[#00d9ff] text-white'
              : 'text-gray-300 hover:bg-gray-700 hover:text-white'
          }`}
        >
          {i}
        </button>
      )
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push(
          <span key="ellipsis-end" className="px-1 sm:px-2 text-gray-500">
            ...
          </span>
        )
      }
      pages.push(
        <button
          key={totalPages}
          onClick={() => onPageChange(totalPages)}
          className="px-2 sm:px-3 py-1 sm:py-2 rounded-md text-xs sm:text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white transition-colors"
        >
          {totalPages}
        </button>
      )
    }

    return pages
  }

  return (
    <div className="flex flex-wrap items-center justify-center gap-2 mt-6 sm:mt-8 mb-3 sm:mb-4 px-2 text-center">
      {/* Previous button */}
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={!hasPreviousPage}
        className={`px-3 sm:px-4 py-1 sm:py-2 rounded-md text-xs sm:text-sm font-medium transition-colors ${
          hasPreviousPage
            ? 'bg-gray-800 text-white hover:bg-gray-700'
            : 'bg-gray-900 text-gray-600 cursor-not-allowed'
        }`}
      >
        Previous
      </button>

      {/* Page numbers */}
      <div className="flex flex-wrap items-center justify-center gap-1 sm:gap-2">
        {renderPageNumbers()}
      </div>

      {/* Next button */}
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={!hasNextPage}
        className={`px-3 sm:px-4 py-1 sm:py-2 rounded-md text-xs sm:text-sm font-medium transition-colors ${
          hasNextPage
            ? 'bg-gray-800 text-white hover:bg-gray-700'
            : 'bg-gray-900 text-gray-600 cursor-not-allowed'
        }`}
      >
        Next
      </button>
    </div>
  )
}

export default Pagination
